import { render } from "./package_nationality.vue?vue&type=template&id=068e9944&scoped=true"
import script from "./package_nationality.vue?vue&type=script&lang=js"
export * from "./package_nationality.vue?vue&type=script&lang=js"

import "./package_nationality.vue?vue&type=style&index=0&id=068e9944&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068e9944"]])

export default __exports__